// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2De_Q","right":"Footer_right__uilvV","buttons":"Footer_buttons__2Zy1d"};